/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_Deep_Focus_TitleInputs */

const en_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Allow List`)
};

const ar_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائمة السماح المخصصة`)
};

const de_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte Erlaubnisliste`)
};

const es_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de permitidos personalizada`)
};

const fr_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste d'autorisations personnalisée`)
};

const it_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista App Consentite personalizzata`)
};

const ja_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可リストのカスタマイズ`)
};

const ko_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커스텀 허용 리스트`)
};

const pt_br_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de permissões personalizada`)
};

const ru_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка списка разрешений`)
};

const th_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการอนุญาตที่กำหนดเอง`)
};

const tr_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel İzin Listesi`)
};

const zh_cn_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义白名单`)
};

const zh_tw_subscription_service_level_compare_deep_focus_title = /** @type {(inputs: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自訂允許名單`)
};

/**
* | output |
* | --- |
* | "Custom Allow List" |
*
* @param {Subscription_Service_Level_Compare_Deep_Focus_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_deep_focus_title = /** @type {((inputs?: Subscription_Service_Level_Compare_Deep_Focus_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_Deep_Focus_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_deep_focus_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_deep_focus_title(inputs)
	return zh_tw_subscription_service_level_compare_deep_focus_title(inputs)
});